// extracted by mini-css-extract-plugin
module.exports = {"popularListWrap":"mostPopularList_popularListWrap__2hteN","popularLisCardWrap":"mostPopularList_popularLisCardWrap__5ahdt"};